import React, { PureComponent } from 'react'
import { DsStack, DsTypography } from '@am92/react-design-system'

import getWithPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import PageWrapper from '~/src/Components/PageWrapper'
import StaticContent from '~/src/Components/StaticContent'

import PRIVACY_POLICY_PAGE_CONSTANTS from './PrivacyPolicy.PageConstants'
import { T_PRIVACY_POLICY_PAGE_CONSTANTS } from './PrivacyPolicy.PageConstants/TYPES'

export interface ITermsAndConditionsgPageProps
  extends IWithPageConstantsProps<T_PRIVACY_POLICY_PAGE_CONSTANTS> {}

class TermsAndConditionsgPage extends PureComponent<ITermsAndConditionsgPageProps> {
  render() {
    const { PAGE_CONSTANTS } = this.props
    return (
      <PageWrapper>
        <DsStack direction='column' spacing='var(--ds-spacing-frostbite)'>
          <DsTypography variant='subheadingSemiboldLarge'>
            {PAGE_CONSTANTS.PAGE_KICKER}
          </DsTypography>
          <DsTypography variant='displayBoldMedium'>
            {PAGE_CONSTANTS.PAGE_TITLE}
          </DsTypography>
        </DsStack>
        <StaticContent pageContent={PAGE_CONSTANTS.PAGE_CONTENT} />
      </PageWrapper>
    )
  }
}

const withPageConstants = getWithPageConstants<T_PRIVACY_POLICY_PAGE_CONSTANTS>(
  PRIVACY_POLICY_PAGE_CONSTANTS
)

export default withPageConstants(TermsAndConditionsgPage)
